import api from '@/api/api';
import { FILES_API } from '@/variables';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    upload_label(context, payload) {
      const { form } = payload;

      return api().post(`${FILES_API}/label`, form)
        .then((resp) => {
          if (resp.status !== 201) throw new Error();
          return resp.data;
        });
    },
  },
};
